import { combineReducers } from "redux";
import appointmentbooking from "../features/admin/exploreproperty/appointmentbooking/Slice";
import rescheduleappointmentbooking from "../features/admin/exploreproperty/rescheduleappointmentbooking/Slice";


const exploreproperty = combineReducers({
  appointmentbooking: appointmentbooking,
  rescheduleappointmentbooking: rescheduleappointmentbooking,
});

export default exploreproperty;
